<script setup lang="ts">

</script>

<template>
    Forbidden!!!!
</template>

<style scoped lang="scss">

</style>